import { ArrowDown, ArrowUp, Minus } from 'lucide-react';
import type { Delta } from './result-trend.logic';
import { signed } from '#client/lib/format';

/**
 * Which way a value moved since the previous visit.
 *
 * **Neutral tokens, never the critical or positive ones.** Up is not bad and
 * down is not good — that depends entirely on the analyte, and nothing in this
 * schema knows which. Rising haemoglobin and rising creatinine are not the same
 * news. The arrow carries the direction; red stays reserved for the range flag,
 * which is the only clinically sanctioned signal in this app.
 */
export function TrendArrow({ delta }: { delta: Delta }) {
  const Icon = delta.direction === 'up' ? ArrowUp : delta.direction === 'down' ? ArrowDown : Minus;

  const change =
    delta.percent === null
      ? signed(delta.absolute, String(delta.absolute))
      : signed(delta.percent, `${delta.percent.toFixed(1)}%`);

  return (
    <span
      className="c-trend-arrow"
      // The figure, not a verdict about it. "Improving" would be the judgement
      // `result-trend.logic.ts` refuses to make on a pathologist's behalf.
      title={`${change} since the previous visit`}
    >
      <Icon aria-hidden />
      <span className="sr-only">{change} since the previous visit</span>
    </span>
  );
}
